import api from "./api";

export const API_BASE = `${process.env.REACT_APP_BACKEND_URL}/api`;
export const getToken = () => localStorage.getItem("motora_token");
export const fileUrl = (path) => `${API_BASE}/files/${path}?auth=${getToken()}`;
export const pdfUrl = (id) => `${API_BASE}/history/${id}/pdf?auth=${getToken()}`;

export async function uploadMedia(file, kind) {
  const fd = new FormData();
  fd.append("file", file);
  const { data } = await api.post(`/upload?kind=${kind}`, fd, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return data;
}

export function downloadPdf(id) {
  const a = document.createElement("a");
  a.href = pdfUrl(id);
  a.download = `diagnosi-${id}.pdf`;
  document.body.appendChild(a);
  a.click();
  a.remove();
}
